// extracted by mini-css-extract-plugin
export default {"content":"SecurityModal_content__YmqP9"};